
import { inject } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpService } from "../HttpClientServices/Http.service";
import { DataSourceType } from 'src/app/shared/Enums/DatasourceTypeEnum';
import { DataTypes } from "src/app/shared/Enums/DataTypesEnum";
import { IDataSource } from "BI-Libraries/BI-Interfaces/projects/bi-interfaces/src/public-api";
import { UserInfo } from "../../../userInfo";
import { FormGroup } from "@angular/forms";

export class DataSourceService extends BehaviorSubject<any> implements IDataSource {
  private _params: { Name: string; Operator: string; value: string; DataType: DataTypes; }[];
  get Params() {
    return this._params;
  }
  //: { Name: string; Operator: string; value: string; DataType: DataTypes; }[];
  Key: string;
  Key2: string;
  Key3: string;
  Key4: string;
  Key5: string;
  Key6: string;
  Columns: { Name: string; DataType: DataTypes; Length?: number }[];
  Type: any;
  IsClientSideFilter: boolean;
  LocalData: boolean = false;
  data: any[] = [];
  loading: boolean;
  APIURL: string;
  POSTAPIURL: string | undefined;
  PUTAPIURL: string | undefined;
  DELETEAPIURL: string | undefined;
  HasPaging: boolean = true;
  excludeDataFromReq: Array<string> = ['']
  excludeTimeFromReq: Array<string> = [];

  private _state: { skip: number, take: number, sort: [] } = { skip: 0, take: 10, sort: [] };

  public get state() {
    return this._state;
  }

  public set state(value: { skip: number, take: number, sort: [] }) {
    this._state = value;
  }
  // Setter
  set Params(value: { Name: string; Operator: string; value: string; DataType: DataTypes; }[]) {
    this._params = value;

    // TODO: remove the overriden of skip and take, and use the skip and take in the read function
    this.state.skip = 0;
    this.state.take = 10;
    if (this.HasPaging)
      this.read(`$skip=0&$top=10&$count=true`);
    else
      this.read(``);
  }
  set _APIURL(value: string) {
    this.APIURL = value;

    // TODO: remove the overriden of skip and take, and use the skip and take in the read function
    this.state.skip = 0;
    this.state.take = 10;
    if (this.HasPaging)
      this.read(`$skip=0&$top=10&$count=true`);
    else
      this.read(``);

  }
  set _HasPaging(value: boolean) {
    this.HasPaging = value;
  }
  private http = inject(HttpService);
  constructor() {
    super([])
  }
  public read(filter: string): void {

    if (this.APIURL) {
      this.http.fetch(this.formatAPIURLWithFilter(filter), this.formatFilter(filter)).subscribe((data: any[]) => {
        this.data = data;
        super.next(data);
        this.loading = false;
      });
    }
    else if (this.LocalData == true) {
      super.next(this.data);
      this.loading = false;
    }

  }
  private formatAPIURL(APIURL: string): string {
    if (APIURL?.includes('?')) {
      return APIURL;
    }
    return APIURL + "?";
  }
  formatFilter(filter: string): string {
    if (this.Type == DataSourceType.odata) {
      return this.formatODataFilter(filter);
    }
    return filter;
  }
  private formatODataFilter(filter: string): string {
    if (this._params?.length > 0) {
      var _params: string = "$filter=";
      this._params.forEach((param) => {
        if (param.Operator == "startswith") {
          _params += ` startswith(${param.Name} , ${this.ParamValue(param.value, param.DataType)}) and `;
        }
        else {
          _params += `${param.Name} ${param.Operator} ${this.ParamValue(param.value, param.DataType)} and `;
        }
      })
      let lastIndex = _params.lastIndexOf('and'); // Remove the last occurrence of 'and' from the string
      if (lastIndex !== -1) { _params = _params.slice(0, lastIndex) + _params.slice(lastIndex + 3); }
      // _params += '&'
      if (filter != "" && filter != undefined) {
        if (filter.includes("$filter="))
          filter = filter.replace("$filter=", _params + ' and ');
        else filter = _params + '&' + filter;


      } else {
        filter = _params;
      }
    }
    if (filter) {
      filter = this.removeTimeFromDatetime(filter);
    }
    if (this.APIURL?.includes('?')) filter = "&" + filter;
    if (this.APIURL?.includes('$filter') && filter.includes('$filter')) {
      filter = this.insertSubstring(this.APIURL, filter);
    }
    return filter;
  }
  private removeTimeFromDatetime(datetimeString: string) {
    /*const regex = /T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
    const newDatetimeString = datetimeString.replace(regex, "");
    return newDatetimeString;*/
    // we have issue in sending time in filter with time zone which diff in time zone will be added to time filter so we should remove part time from dates sent in the filters
    const dateStr = /(r=| )Units Date /g;
    let newQueryStr = datetimeString.replace(dateStr, '$1date(Units Date) ');
    const regex = /T00:00:00\.000Z/gi;
    const noTimeZoneQueryStr = newQueryStr.replace(regex, '');
    return noTimeZoneQueryStr;
  }
  private ParamValue(value: string, Type: DataTypes): string {
    switch (Type) {
      case DataTypes.Text:
        return "'" + value + "'";
      default:
        return value;
    }
  }
  get(APIURL: string) {
    return this.http.get(this.formatAPIURL(APIURL));
  }
  getResponsetext(APIURL: string) {
    return this.http.getResponsetext(this.formatAPIURL(APIURL));
  }
  delete(id: string): any {
    id = this.ReplaceHTMLCharFromKeyValue(id); // bug 13443
    return this.http.delete(`${this.DELETEAPIURL == undefined ? this.APIURL : this.DELETEAPIURL}/${id}`)
  }
  add(data: any): any {
    return this.http.add(`${this.POSTAPIURL == undefined ? this.APIURL : this.POSTAPIURL}`, data)
  }
  edit(data: any, id: string): any {
    id = this.ReplaceHTMLCharFromKeyValue(id); // bug 13443
    return this.http.edit(`${this.PUTAPIURL == undefined ? this.APIURL.split('?$')[0] : this.PUTAPIURL}/${id}`, data)
  }
  patch(data: any, id: string): any {
    id = this.ReplaceHTMLCharFromKeyValue(id); // bug 13443
    return this.http.patch(`${this.PUTAPIURL == undefined ? this.APIURL.split('?$')[0] : this.PUTAPIURL}/${id}`, data)
  }
  batch(CreatedItemArray: Array<any>, UpdatedItemArray: Array<any>, DeletedItemArray: Array<any>): any {
    if (CreatedItemArray.length > 0 || UpdatedItemArray.length > 0 || DeletedItemArray.length > 0)
      return this.http.add('$batch', this.PrepareBatchRequestData(CreatedItemArray, UpdatedItemArray, DeletedItemArray));
  }
  public PrepareBatchRequestData(CreatedItemArray: Array<any>, UpdatedItemArray: Array<any>, DeletedItemArray: Array<any>) {
    var type = '';
    var batchRequestData = { "requests": [] };
    if (DeletedItemArray) {
      type = 'delete';
      DeletedItemArray.forEach(deletedItem => {
        var url = "";
        if (this.Key2) {
          url = (this.DELETEAPIURL == undefined ? this.APIURL : this.DELETEAPIURL) + '/' + this.getQueryStr(this.Key, deletedItem.getRawValue()[this.Key])
            + (this.Key2 ? "," + this.getQueryStr(this.Key2, deletedItem.getRawValue()[this.Key2]) : "")
            + (this.Key3 ? "," + this.getQueryStr(this.Key3, deletedItem.getRawValue()[this.Key3]) : "")
            + (this.Key4 ? "," + this.getQueryStr(this.Key4, deletedItem.getRawValue()[this.Key4]) : "")
            + (this.Key5 ? "," + this.getQueryStr(this.Key5, deletedItem.getRawValue()[this.Key5]) : "")
            + (this.Key6 ? "," + this.getQueryStr(this.Key6, deletedItem.getRawValue()[this.Key6]) : "");
        }
        else {
          url = (this.DELETEAPIURL == undefined ? this.APIURL : this.DELETEAPIURL) + '/' + deletedItem.getRawValue()[this.Key];
        }

        var deletedRequest = {
          "id": deletedItem.controls['R_WID'].value.toString(),
          "method": "delete",
          "url": url,
          "headers": {
            "content-type": "application/json;odata.metadata=minimal;odata.streaming=true;",
            "odata-version": "4.0"
          }
        }
        batchRequestData['requests'].push(deletedRequest);
      });
    }
    if (CreatedItemArray) {
      type = 'POST';
      CreatedItemArray.forEach(createdItem => {

        var body = createdItem.getRawValue();
        this.excludeDataFromReq.forEach(field => {
          delete body[field];
        })

        var postURL = (this.POSTAPIURL == undefined ? this.APIURL : this.POSTAPIURL) + '/';
        var createRequest = {
          "id": createdItem.controls['R_WID'].value.toString(),
          "method": "POST",
          "url": postURL,
          "headers": {
            "content-type": "application/json;odata.metadata=minimal;odata.streaming=true;",
            "odata-version": "4.0"
          },
          "body": body
        }
        batchRequestData['requests'].push(createRequest);
      });
    }
    if (UpdatedItemArray) {
      type = 'PATCH';
      UpdatedItemArray.forEach(updatedItem => {
        if (updatedItem.hasOwnProperty('ModifiedOn'))
          updatedItem['ModifiedOn'] = new Date()
        if (updatedItem.hasOwnProperty('ModifiedBy'))
          updatedItem['ModifiedBy'] = UserInfo.UserName;

        
        const updatedvalue = this.GetUpdatedProperties(updatedItem);
        var body = updatedItem.getRawValue();
        this.excludeDataFromReq.forEach(field => {
          delete body[field];
        })

        var url = ""
        console.log(body, this.Key);
        if (this.Key2) {

          url = (this.PUTAPIURL == undefined ? this.APIURL : this.PUTAPIURL) + '/' + this.getQueryStr(this.Key, body[this.Key])
            + (this.Key2 ? "," + this.getQueryStr(this.Key2, body[this.Key2]) : "")
            + (this.Key3 ? "," + this.getQueryStr(this.Key3, body[this.Key3]) : "")
            + (this.Key4 ? "," + this.getQueryStr(this.Key4, body[this.Key4]) : "")
            + (this.Key5 ? "," + this.getQueryStr(this.Key5, body[this.Key5]) : "")
            + (this.Key6 ? "," + this.getQueryStr(this.Key6, body[this.Key6]) : "");
        }
        else {
          url = (this.PUTAPIURL == undefined ? this.APIURL : this.PUTAPIURL) + '/' + body[this.Key]
        }
        

        var updateRequest = {
          "id": updatedItem.controls['R_WID'].value.toString(),
          "method": type,
          "url": url,
          "headers": {
            "content-type": "application/json;odata.metadata=minimal;odata.streaming=true;",
            "odata-version": "4.0"
          },
          "body": updatedvalue
        }
        batchRequestData['requests'].push(updateRequest);
      });

    }
    return batchRequestData;
  }
  getQueryStr(key, value: any): string {
    var keyDataType = this.Columns.filter(f => f.Name == key)[0].DataType;
    switch (keyDataType) {
      case DataTypes.Text:
        return key + "='" + value + "'";
        break;
      default:
        return key + "=" + value;
        break;
    }

  }
  ReplaceHTMLCharFromKeyValue(value: any): string {
    if (typeof value === 'string' || value instanceof String) {
      value = value.replace("\\", "%5C");
      value = value.replace("#", "%23");
      return value;
    }
    else
      return value;
  }

  insertSubstring(str: any, substringToInsert: any) {
    var result = "";
    // Check if the string contains "$filter=".
    const filterIndex = str.indexOf('$filter=');

    if (filterIndex !== -1) {
      // Find the next "&" character after "$filter=".
      const nextAmpersandIndex = str.indexOf('&', filterIndex);

      if (nextAmpersandIndex !== -1) {
        // Insert the substring after "$filter=" and before the next "&".
        result = str.substring(0, nextAmpersandIndex) + " and " + substringToInsert.replace("&$filter=", " ").replace("$filter=", " ") + str.substring(nextAmpersandIndex);
      } else {
        // If there's no "&" after "$filter=", insert at the end.
        result = str + " and " + substringToInsert.replace("&$filter=", " ").replace("$filter=", " ");
      }
    }

    const indexOfEndURL = result.indexOf('?');
    result = result.substring(indexOfEndURL);
    // If "$filter=" is not found, return the original string.
    return result;
  }
  formatAPIURLWithFilter(filter: string): string {
    let APIURL = this.APIURL;
    if (this.APIURL?.includes('$filter') && filter?.includes('$filter')) {
      const indexOfEndURL = APIURL.indexOf('?');
      APIURL = APIURL.substring(0, indexOfEndURL);
    } else {
      APIURL = this.formatAPIURL(this.APIURL);
    }
    return APIURL;
  }

  public GetUpdatedProperties(myForm: FormGroup<any> | undefined): any {
    const updatedControls = [];
    let updatedProp: any = {}
    if (!myForm)
      return null
    for (const controlName in myForm.controls) {
      if (myForm.get(controlName) && !myForm.get(controlName)?.pristine) {
        updatedControls.push(controlName);
        updatedProp[controlName] = myForm.get(controlName)?.getRawValue();
      }
    }
    return updatedProp;
  }
}
